import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  data: {},
    weeks: [],
  products: [],
  businessDetails: {},
  userBookingDetails: {},
  userDetailsConfig: {},
  platformDisclaimer: "",
  adsTrackings : {},
  paymentGateways: {},
  bookingPlatformAvail: null
};



const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetBookingSlice: (state, action) => {
      return { ...initialState };
    },
    setBookingProducts: (state, action) => {
        state.products = action.payload;
    },
    updateBusinessDetails: (state, action) => {
        state.businessDetails = action.payload;
    },
    updateUserDetailsConfig: (state, action) => {
        state.userDetailsConfig = action.payload;
    },
    updatePlatformDisclaimer: (state, action) => {
        state.platformDisclaimer = action.payload;
    },
    updateAdsTracking: (state, action) => {
      let { key, value } = action.payload;
      state.adsTrackings[key] = value;
    },
    updatePropertyVal: (state, action) => {
      let { key, val } = action.payload;
      state[key] = val;
    },
    setBookingPlatformDBData: (state, action) => {
        let dbData = action.payload;
        state.data = dbData;
        state.products = dbData?.products || []
        state.businessDetails = dbData?.businessDetails || {}
        state.userBookingDetails = dbData?.userBookingDetails || {}
        state.userDetailsConfig = dbData?.userDetailsConfig || {}
        state.platformDisclaimer = dbData?.disclaimer || ""
        state.adsTrackings = dbData?.integrations?.adsTracking || {}
        state.paymentGateways = dbData?.integrations?.paymentGateway || {}
    }
  },
  extraReducers: (builder) => { },
});

export const {resetBookingSlice,updateBusinessDetails, setBookingProducts, setBookingPlatformDBData, updateUserDetailsConfig, updatePlatformDisclaimer, updateAdsTracking, updatePropertyVal} = bookingSlice.actions;


export const SelectWeeks = (state) => state.booking.weeks;
export const SelectBookingStatus = (state) => state.booking.status;
export const SelectBookingProducts = (state) => state.booking.products;
export const SelectBusinessDetails = (state) => state.booking.businessDetails;
export const SelectUserBookingDetails = (state) => state.booking.userBookingDetails;
export const SelectUserDetailsConfig = (state) => state.booking.userDetailsConfig;
export const SelectPlatformDisclaimer = (state) => state.booking.platformDisclaimer;
export const SelectAdsTrackings = (state) => state.booking.adsTrackings;
export const SelectPaymentGateways = (state) => state.booking.paymentGateways;
export const SelectBookingPlatformAvail = (state) => state.booking.bookingPlatformAvail;



export default bookingSlice.reducer;
